import FieldSet from "./FieldSet";
import Checks from "./Checks";

export default class ReportParameters {
    
    public constructor(DictionaryParameters: Array<[string, string]> = [], FieldSets: FieldSet[] = [], Checks: Checks[] = []) 
    {
        this.DictionaryParameters = DictionaryParameters;
        this.FieldSets = FieldSets;
        this.Checks = Checks;
    }

    public DictionaryParameters: Array<[string, string]>;

    public FieldSets: FieldSet[];

    public Checks: Checks[];
}